if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      const searchContainer = this.closest('.header-native-search');
      const searchForm = this.closest('form');

      if (searchContainer) {
        this.searchInput = searchContainer.querySelector('input[name="q"]');
      } else if (searchForm) {
        this.searchInput = searchForm.querySelector('input[name="q"]');
      }

      if (!this.searchInput) {
        return;
      }

      this.searchInput.addEventListener('input', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

      const predictiveSearchUrl = new URL(theme.routes.base + theme.routes.predictiveSearch, window.location.origin);
      predictiveSearchUrl.searchParams.set('q', terms);
      predictiveSearchUrl.searchParams.set('section_id', 'search-suggestions');
      predictiveSearchUrl.searchParams.set('resources[limit]', '4');
      predictiveSearchUrl.searchParams.set('resources[limit_scope]', 'each');
      predictiveSearchUrl.searchParams.set('resources[type]', 'product');
      predictiveSearchUrl.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      predictiveSearchUrl.searchParams.set('resources[options][unavailable_products]', 'hide');

      fetch(predictiveSearchUrl.toString(), {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) {
            this.insertAdjacentElement('beforeend', results.firstElementChild);
          }
        })
        .catch((error) => {
          console.warn(error); // eslint-disable-line no-console
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
